import type { ApolloClient } from "@apollo/client";
import { PERSON_TIMELINE_QUERY } from "@/pages/people/[pgaId]/interactions/person-history/queries";
import { GET_PERSON_INTERACTIONS_QUERY } from "./queries";

export const PERSON_INTERACTION_VIEW_QUERIES = [GET_PERSON_INTERACTIONS_QUERY, PERSON_TIMELINE_QUERY] as const;

type PersonWithPgaId = {
  pgaId: string;
  selected?: boolean;
};

export function shouldRefetchPersonInteractionViewsForSingleCreate(
  pagePgaId: string | undefined,
  selectedPgaId: string | undefined | null
): boolean {
  return Boolean(pagePgaId && selectedPgaId && pagePgaId === selectedPgaId);
}

export function shouldRefetchPersonInteractionViewsForGroupCreate(
  pagePgaId: string | undefined,
  people: PersonWithPgaId[]
): boolean {
  if (!pagePgaId) {
    return false;
  }

  return people.some((person) => person.selected !== false && person.pgaId === pagePgaId);
}

export function refetchPersonInteractionViews(apolloClient: Pick<ApolloClient<object>, "refetchQueries">) {
  return apolloClient.refetchQueries({
    include: [...PERSON_INTERACTION_VIEW_QUERIES]
  });
}
